import './index.css';
export { default as SmallCabinet } from './SmallCabinet';
export { default as FullCabinet } from './FullCabinet';
